/**
 * B2B Article — Table of Contents
 * Builds TOC links from H2 headings in the article body.
 * Handles sticky sidebar TOC (desktop) and collapsible mobile TOC.
 */

(function () {
  const content = document.querySelector('.b2b-article__body');
  const tocNav = document.getElementById('b2b-toc-nav');
  const mobileTocList = document.getElementById('b2b-mobile-toc-list');
  const mobileTocToggle = document.querySelector('.b2b-article__mobile-toc-toggle');
  const mobileToc = document.getElementById('b2b-mobile-toc');

  if (!content || !tocNav) return;

  // ── Auto-tag tables with 4+ columns as responsive-table ──────────────────
  content.querySelectorAll('table').forEach(function (table) {
    var cols = table.querySelector('tr') ? table.querySelector('tr').children.length : 0;
    if (cols >= 4 && !table.classList.contains('responsive-table')) {
      table.classList.add('responsive-table');
    }
  });

  // ── Mid-article CTA injection ─────────────────────────────────────────────
  (function () {
    var tmpl = document.getElementById('b2b-mid-cta-template');
    if (!tmpl) return;

    var ctaNode = tmpl.content.cloneNode(true);
    var inserted = false;

    // 1. Marker: look for any element or text node containing only [mid-article-cta]
    var allNodes = content.querySelectorAll('p, div, li, span');
    for (var i = 0; i < allNodes.length; i++) {
      if (allNodes[i].textContent.trim() === '[mid-article-cta]') {
        allNodes[i].parentNode.replaceChild(ctaNode, allNodes[i]);
        inserted = true;
        break;
      }
    }
    // Also walk direct text nodes of the article body
    if (!inserted) {
      var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim() === '[mid-article-cta]') {
          var placeholder = document.createElement('div');
          node.parentNode.replaceChild(placeholder, node);
          placeholder.parentNode.replaceChild(ctaNode, placeholder);
          inserted = true;
          break;
        }
      }
    }

    // 2. Fallback: after first table
    if (!inserted) {
      var firstTable = content.querySelector('table');
      if (firstTable) {
        firstTable.parentNode.insertBefore(ctaNode, firstTable.nextSibling);
        inserted = true;
      }
    }

    // 3. Fallback: after second H2
    if (!inserted) {
      var h2s = content.querySelectorAll('h2');
      if (h2s.length >= 2) {
        h2s[1].parentNode.insertBefore(ctaNode, h2s[1].nextSibling);
      }
    }
  })();

  const headings = content.querySelectorAll('h2');
  if (headings.length < 3) {
    // Not enough headings — hide TOC entirely
    const sidebar = document.getElementById('b2b-toc');
    if (sidebar) sidebar.style.display = 'none';
    if (mobileToc) mobileToc.style.display = 'none';
    return;
  }

  function smoothScrollTo(heading) {
    const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10);
    const top = heading.getBoundingClientRect().top + window.scrollY - offset - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // Build TOC links
  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = 'section-' + index;
    }

    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    link.className = 'b2b-article__toc-link';
    link.addEventListener('click', function (e) {
      e.preventDefault();
      smoothScrollTo(heading);
    });
    tocNav.appendChild(link);

    if (mobileTocList) {
      const mobileLink = link.cloneNode(true);
      mobileLink.addEventListener('click', function (e) {
        e.preventDefault();
        mobileTocList.hidden = true;
        mobileTocToggle.setAttribute('aria-expanded', 'false');
        smoothScrollTo(heading);
      });
      mobileTocList.appendChild(mobileLink);
    }
  });

  // Highlight active section on scroll (desktop sidebar)
  const tocLinks = tocNav.querySelectorAll('.b2b-article__toc-link');

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        tocLinks.forEach(function (link) {
          link.classList.remove('is-active');
          if (link.getAttribute('href') === '#' + entry.target.id) {
            link.classList.add('is-active');
          }
        });
      }
    });
  }, { rootMargin: '0px 0px -60% 0px' });

  headings.forEach(function (heading) {
    observer.observe(heading);
  });

  // Responsive tables — auto-detect 4+ column tables and apply stacking
  content.querySelectorAll('table').forEach(function (table) {
    var headers = table.querySelectorAll('thead th');
    if (headers.length < 4) return;

    table.classList.add('responsive-table');

    var headerLabels = Array.from(headers).map(function (th) {
      return th.textContent.trim();
    });

    table.querySelectorAll('tbody tr').forEach(function (row) {
      row.querySelectorAll('td').forEach(function (td, i) {
        if (headerLabels[i]) {
          td.setAttribute('data-label', headerLabels[i]);
        }
      });
    });
  });

  // FAQ accordion toggle
  document.querySelectorAll('.b2b-article__faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var answerId = btn.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);
      btn.setAttribute('aria-expanded', String(!isExpanded));
      if (answer) answer.hidden = isExpanded;
      if (!isExpanded) {
        gaEvent('faq_expand', {
          question_text: btn.textContent.trim(),
          post_slug: blogSlug
        });
      }
    });
  });

  // Scroll-progress indicator (desktop TOC)
  var progressBar = document.getElementById('b2b-toc-progress-bar');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? Math.min(100, Math.round((window.scrollY / total) * 100)) : 0;
      progressBar.style.width = pct + '%';
    }, { passive: true });
  }

  // Mobile TOC toggle
  if (mobileTocToggle && mobileTocList) {
    mobileTocToggle.addEventListener('click', function () {
      const isExpanded = mobileTocToggle.getAttribute('aria-expanded') === 'true';
      mobileTocToggle.setAttribute('aria-expanded', String(!isExpanded));
      mobileTocList.hidden = isExpanded;
    });

    // Sticky mobile TOC on scroll
    const mobileTocTop = mobileToc.getBoundingClientRect().top + window.scrollY;
    window.addEventListener('scroll', function () {
      if (window.scrollY > mobileTocTop) {
        mobileToc.classList.add('is-sticky');
      } else {
        mobileToc.classList.remove('is-sticky');
      }
    }, { passive: true });
  }

  // ── GA4 Event Tracking ────────────────────────────────────────────────────

  function gaEvent(name, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', name, params);
  }

  var blogSlug = window.location.pathname.replace(/\//g, '_').replace(/^_/, '');

  // 6. blog_to_inquiry — persist landing slug for attribution on inquiry form pages
  try {
    localStorage.setItem('landing_blog_slug', blogSlug);
    localStorage.setItem('landing_blog_ts', Date.now().toString());
  } catch (e) {}

  // 1. scroll_depth — fires once each at 25 / 50 / 75 / 100 %
  var scrollMilestones = [25, 50, 75, 100];
  var firedMilestones = {};
  window.addEventListener('scroll', function () {
    var scrolled = window.scrollY + window.innerHeight;
    var total = document.documentElement.scrollHeight;
    var pct = Math.floor((scrolled / total) * 100);
    scrollMilestones.forEach(function (milestone) {
      if (pct >= milestone && !firedMilestones[milestone]) {
        firedMilestones[milestone] = true;
        gaEvent('scroll_depth', { depth_percentage: milestone, post_slug: blogSlug });
      }
    });
  }, { passive: true });

  // 2. toc_click — fires when a TOC link is clicked (desktop or mobile)
  document.querySelectorAll('.b2b-article__toc-link').forEach(function (link) {
    var isMobile = link.closest('#b2b-mobile-toc-list') !== null;
    link.addEventListener('click', function () {
      gaEvent('toc_click', {
        toc_target_anchor: link.getAttribute('href') || '',
        post_slug: blogSlug,
        device: isMobile ? 'mobile' : 'desktop'
      });
    });
  });

  // 3. cta_click — header, mid-article, and closing CTA buttons
  var headerCtaBtn = document.querySelector('.article__header-cta-btn');
  if (headerCtaBtn) {
    headerCtaBtn.addEventListener('click', function () {
      gaEvent('cta_click', {
        cta_position: 'header',
        cta_label: headerCtaBtn.textContent.trim(),
        cta_destination: headerCtaBtn.pathname || headerCtaBtn.getAttribute('href') || '',
        post_slug: blogSlug
      });
    });
  }

  document.addEventListener('click', function (e) {
    var midBtn = e.target.closest('.b2b-article__mid-cta-btn');
    if (midBtn) {
      gaEvent('cta_click', {
        cta_position: 'mid_article',
        cta_label: midBtn.textContent.trim(),
        cta_destination: midBtn.pathname || midBtn.getAttribute('href') || '',
        post_slug: blogSlug
      });
    }
  });

  var closingCta = document.querySelector('.b2b-article__closing-cta');
  if (closingCta) {
    closingCta.querySelectorAll('.b2b-article__cta-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = btn.classList.contains('b2b-article__cta-btn--primary') ? 'closing_primary' : 'closing_secondary';
        gaEvent('cta_click', {
          cta_position: position,
          cta_label: btn.textContent.trim(),
          cta_destination: btn.pathname || btn.getAttribute('href') || '',
          post_slug: blogSlug
        });
      });
    });
  }

  // 3b. download_event — direct download button
  var downloadBtn = document.querySelector('.b2b-article__download-btn');
  if (downloadBtn) {
    downloadBtn.addEventListener('click', function () {
      gaEvent('download_event', {
        asset_filename: downloadBtn.getAttribute('href').split('/').pop().split('?')[0],
        gate_method: 'direct',
        post_slug: blogSlug
      });
    });
  }

  // 4. related_click — related resources grid cards
  document.querySelectorAll('.b2b-article__related-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var title = card.querySelector('.b2b-article__related-card-title');
      var intent = card.querySelector('.b2b-article__related-intent');
      gaEvent('related_click', {
        card_title: title ? title.textContent.trim() : '',
        card_url: card.href || '',
        card_intent_band: intent ? intent.textContent.trim() : '',
        post_slug: blogSlug
      });
    });
  });

  // 5. internal_link_click — links inside the article body that stay on allora-usa.com
  content.querySelectorAll('a[href]').forEach(function (a) {
    if (a.hostname && a.hostname !== window.location.hostname) return;
    var section = (function () {
      var el = a;
      while (el && el !== content) {
        if (el.previousElementSibling && el.previousElementSibling.matches('h2')) {
          return el.previousElementSibling.textContent.trim();
        }
        el = el.parentElement;
      }
      return '';
    })();
    a.addEventListener('click', function () {
      gaEvent('internal_link_click', {
        source_section: section,
        target_url: a.pathname,
        post_slug: blogSlug
      });
    });
  });

  // 6. blog_to_inquiry — blocked pending cookie/localStorage mechanism decision
  // Will persist landing_blog_slug on article load and read it back on inquiry form submit.

})();
